import React from 'react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '@reverbdotcom/commons/src/url_helpers';
import SearchAltIcon from '@reverbdotcom/commons/design-system/icons/core/search-alt.svg?component';
import { buttonClassName } from '../rc/RCButton/styling';
import { MParticleEvent } from '../elog/mparticle_types';
import { RCIcon } from '../rc/RCIcon';
import I18n from 'i18n-js';

interface Props {
  categoryLabel: string;
  /*
    Example of marketplaceLinkParams:
    {
      category: "microphones",
      product_type: "pro-audio",
      trait_values: ['83fb54b3-3a74-4221-a1ec-16e6296ab84a']
    }
  */
  marketplaceLinkParams: Object;
  clickEvent?: MParticleEvent;
}

export default function SearchButton(props: Props) {
  const buttonText = I18n.t('commons.homepage.categorySearch.search', { category: props.categoryLabel });

  return (
    <CoreLink
      to={Paths.marketplace.expand(props.marketplaceLinkParams)}
      className={buttonClassName({ variant: 'primary' })}
      clickEvent={props.clickEvent}
    >
      <RCIcon
        svgComponent={SearchAltIcon}
      />
      {buttonText}
    </CoreLink>
  );
}
